// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZFf5","fullView":"styles_fullView__1l1GF"};